import { defaultFlags } from './init';
import * as types from '../types';
import { FlagsAction, FlagsActions, FlagsState } from '../types';
const initialState: FlagsState = {
  scheduleFetch: true,
  liveFetch: true,
  dataOpsFetch: true,
  download: false,
  
};

export const flags = (state: FlagsState = initialState, action: FlagsActions) => {
  switch (action.type) {
    case FlagsAction.LOAD_FLAGS:
      return { ...defaultFlags };
    case FlagsAction.SET_LIVE_FETCH_FLAG:
      return { ...state, liveFetch: action.liveFetch };
    case FlagsAction.SET_PAST_FETCH_FLAG:
      return { ...state, pastFetch: action.pastFetch };
    case FlagsAction.SET_SCHEDULE_FETCH_FLAG:
      return { ...state, scheduleFetch: action.scheduleFetch };
    case FlagsAction.SET_DATAOPS_FETCH_FLAG:
      return { ...state, dataOpsFetch: action.dataOpsFetch };
    case FlagsAction.SET_PRACICE_SAVED_SUCCESSFULLY_FLAG:
      return { ...state, practiceSaved: action.practiceSaved };
    case FlagsAction.SET_ACTION_SUCCESSFULLY_STARTED:
      return { ...state, actionDataOps: { action: action.actionMessage, actionSucceeded: action.actionSucceeded } };
    case FlagsAction.DOWNLOADING_FLAG:
      return{...state, download: action.download };
    case FlagsAction.CREATE_AND_GO_FLAG:
    return {...state, createAndGoFlag: action.createAndGoFlag};
    case FlagsAction.PLAYS_IGNORE_SAVED_FLAG:
      return {...state, playsSavedFlag: action.playsSavedFlag};
    case FlagsAction.GAME_REPROCESS_FLAG:
      return {...state, reprocessFlag: action.reprocessFlag};
    default:
      return state;
  }
};
